import styled from '@emotion/styled';
import React, { Component, ErrorInfo, ReactNode } from 'react';

const ErrorMessage = styled.h2`
  text-align: center;
  margin-top: 10%;
  font-weight: 500;
`;

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || <ErrorMessage>Something went wrong</ErrorMessage>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
